import React, { createRef, useState } from 'react';
import Modal from 'app/components/Modal';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { HPX_THEME } from 'shared/config/themes';
import { Input } from 'semantic-ui-react';
import modalStyles from 'shared/components/modalStyles';
import messages, { FormattedMessage, withValues } from 'shared/messages/messages';

import {
    applyDiscountCoupon,
    getPurchaseCalculations
} from 'shared/actions/cartActions';

import {
    getSelectedCalculations
} from 'shared/selectors/cartSelectors';

import {
    getStore
} from 'shared/services/Store';

const styles = () => ({
    inputGroup: {
        padding: '0.3rem 0'
    },
    ...modalStyles()
});
const DiscountCodeModal = (props) => {
    const { classes, isOpen, onClose, settings, applyDiscountCoupon, calculations, user } = props;
    const [error, setError] = useState(null);
    const [code, setCode] = useState("");
    const store = getStore();
    const uppercase = settings.theme === HPX_THEME;

    let slide = {};
    let slides = [];

    const applyDiscount = async () => {
        let err = await applyDiscountCoupon(user.story_id, calculations?.product_id, code, calculations?.raw_total);

        if (err) {
            setError(<FormattedMessage {...messages[err]} />);
        } else {
            setError(null);
            refreshPurchaseCalculations();
            onClose();
        }
    }

    const refreshPurchaseCalculations = async () => {
        const { user, getPurchaseCalculations } = props;
        const { moments } = store;

        let maxQuantity = moments.allIds.length;

        if (maxQuantity == 0) {
            maxQuantity = props.moments.allIds.length;
        }

        return await getPurchaseCalculations(user.story_id, maxQuantity, code);
    }

    let errorLabel = null;
    if (error) {
        errorLabel = (
            <p className={classes.modalText} style={{ textAlign: 'left', margin: '0.8rem 0', fontSize: '1rem', color: 'red' }}>
                {error}
            </p>
        );
    }

    slide.component = (
        <div>
            <p className={classes.modalHeader}>
                <FormattedMessage {...withValues(messages.cart_coupon_code, { uppercase })} />
            </p>
            <p className={classes.modalText} style={{ textAlign: 'left', margin: '0.8rem 0', fontSize: '1rem' }}>
                <FormattedMessage {...messages.cart_coupon_code_instructions} values={{ br: <br /> }} />
            </p>
            {errorLabel}
            <div className={classes.inputGroup}>
                <Input fluid className={classes.input} name="code" style={{ borderColor: '#aaa' }} onChange={(e) => setCode(e.target.value)} />
            </div>
        </div>
    );

    slide.nextLabel = "Apply";
    slide.onNext = () => applyDiscount();
    slide.skipClose = true;
    slides.push(slide);

    return <Modal slides={slides} open={isOpen} onClose={() => onClose()} />
}

const mapStateToProps = state => ({
    settings: state.kioskReducer.settings,
    user: state.kioskReducer.user,
    calculations: getSelectedCalculations(state),
    moments: state.cartReducer.moments,
});

export default connect(mapStateToProps, { applyDiscountCoupon, getPurchaseCalculations })(withStyles(styles)(DiscountCodeModal));